<template>
  <dx-modal title="Configuração da despesa"
            id="update-expense-modal"
            size="lg"
            :value="true"
            @input="close">
    <st-tabs ref="update-expense-tabs">
      <st-tab id="tab-expense" name="Dados principais">
        <h6 class="text-secondary">{{ form.expense.name }}</h6>
        <div class="columns">
          <div class="column col-2 col-md-3 col-sm-12 form-group"
               :class="{'has-error': $v.form.code.$error}">
            <label class="form-label">Código próprio</label>
            <input type="text" class="form-input text-center"
                   v-model="form.code"
                   v-mask="'00.00.00.00.00'"
                   placeholder="00.00.00.00"
                   @blur="$v.form.code.$touch()"
            />
          </div>
          <div class="column col-4 col-md-4 col-sm-12 form-group"
               :class="{'has-error': $v.form.tableCode.$error}">
            <label class="form-label">Tabela</label>
            <select class="form-select"
                    v-model="form.tableCode"
                    @blur="$v.form.tableCode.$touch()">
              <option value="">[Selecione]</option>
              <option v-for="(text, value) in expenseTables"
                      :value="value" :key="value">
                {{ value }} - {{ text }}
              </option>
            </select>
          </div>
          <div class="column col-6 col-md-5 col-sm-12 form-group">
            <label class="form-label">
              Recebimento do honorário
              <span class="c-hand tooltip tooltip-left"
                    data-tooltip="Quando PF não deduz imposto do convênio">
                  <fa-icon
                    class="text-info"
                    :icon="['fal', 'info-circle']"
                  />
                </span>
            </label>
            <select id="accredited" class="form-select"
                    v-model="form.definition.accredited"
                    @change="changedAccreditation">
              <option value="pf">Recebido pelo profissional [PF]</option>
              <option value="pj">Recebido pela clínica/hospital [PJ]</option>
            </select>
          </div>
          <div class="column col-2 col-md-3 col-sm-12 form-group">
            <label class="form-label">
              Outras taxas (%)
              <span class="c-hand tooltip"
                    data-tooltip="Taxa aplicada após a dedução de imposto">
              <fa-icon
                class="text-info"
                :icon="['fal', 'info-circle']"
              />
            </span>
            </label>
            <div class="input-group">
              <dx-input-number class="form-input"
                               v-model="form.definition.taxValue"
                               :precision="2" maxlength="7" />
              <select class="form-select"
                      v-model="form.definition.taxType"
                      v-if="form.definition.accredited === 'pf'"
                      style="max-width: 2.5rem; background-color: #f8f9fa">
                <option value="pf">PF</option>
                <option value="pj">PJ</option>
              </select>
            </div>
          </div>
          <div class="column col-2 col-md-3 col-sm-12 form-group"
               :class="{'has-error': $v.form.definition.secondSegment.$error}">
            <label class="form-label">
              2º segto. (%)
              <span class="popover popover-right">
              <fa-icon
                class="text-info"
                :icon="['fal', 'info-circle']"
              />
              <div class="popover-container">
                <div class="card">
                  <div class="card-header">
                    <h6>Exemplo de utilização</h6>
                  </div>
                  <div class="card-body">
                    <div class="text-bold">Ceratoscopia</div>
                    <div>1º Olho: R$90,03</div>
                    <div>2º Olho: R$82,31</div>

                    <div class="text-bold mt-2">Fórmula:</div>

                    <div>(2º Olho / 1º Olho) * 100 = <strong>X</strong></div>
                    <div>
                    (R$82,31 / R$90,03) * 100 = <strong class="text-primary">91,42%</strong>
                    </div>

                    <div class="text-bold mt-2">Valor segundo olho:</div>
                    <div>R$90,03 * 91,42% = <strong>R$82,31</strong></div>
                  </div>
                </div>
              </div>
            </span>
            </label>
            <dx-input-number
              class="form-input"
              v-model="form.definition.secondSegment"
              :precision="3"
              maxlength="7"
              @blur="$v.form.definition.secondSegment.$touch()"
            />
          </div>
          <div class="column col-2 col-md-3 col-sm-12 form-group">
            <label class="form-label">Valor assin. laudo</label>
            <dx-input-number class="form-input"
                             v-model="form.definition.reportValue"
                             :precision="2" maxlength="7"
            />
          </div>
          <div class="column col-2 col-md-3 col-sm-12 form-group">
            <label class="form-label">Custo operacional</label>
            <dx-input-number
              class="form-input"
              v-model=form.definition.operationalCostValue
              @change="calcInsuranceValueWithFee"
              :precision="2"
            />
          </div>
          <div class="column col-2 col-md-3 col-sm-12 form-group">
            <label class="form-label">Valor m² do filme</label>
            <dx-input-number
              class="form-input"
              v-model=form.definition.filmValue
              @change="calcInsuranceValueWithFee"
              :precision="2"
            />
          </div>
          <div class="column col-2 col-md-3 col-sm-12 form-group">
            <label class="form-label">Qtde. filme</label>
            <dx-input-number
              class="form-input"
              v-model=form.definition.filmQuantity
              @change="calcInsuranceValueWithFee"
              :precision="4"
            />
          </div>
          <div class="column col-3 col-md-3 col-sm-12 form-group">
            <label class="form-label">Valor honorário</label>
            <dx-input-number
              class="form-input"
              v-model=form.definition.feeValue
              @change="calcInsuranceValueWithFee"
              :precision="2"
            />
          </div>
          <div class="column col-3 col-md-3 col-sm-12 form-group"
               :class="{'has-error': $v.form.definition.$error
             && !$v.form.definition.oneGreaterThanZero}">
            <label class="form-label text-bold">Valor plano</label>
            <dx-input-number
              class="form-input"
              v-model=form.definition.insuranceValue
              @blur="$v.form.definition.$touch()"
              :disabled="hasFee"
              :precision="2"
            />
          </div>
          <div class="column col-3 col-md-3 col-sm-12 form-group"
               :class="{'has-error': $v.form.definition.$error
              && !$v.form.definition.oneGreaterThanZero}">
            <label class="form-label text-bold">Valor paciente</label>
            <dx-input-number
              class="form-input"
              v-model=form.definition.particularValue
              @blur="$v.form.definition.$touch()"
              :precision="2"
            />
          </div>
          <div class="column col-3 col-md-3 col-sm-12 form-group">
            <label class="form-label text-bold">Valor repasse</label>
            <div class="input-group">
              <dx-input-number class="form-input"
                               v-model="form.definition.transferValue"
                               :precision="2" maxlength="7"
              />
              <select class="form-select"
                      v-model="form.definition.transferType"
                      style="max-width: 2.5rem; background-color: #f8f9fa">
                <option value="percent">%</option>
                <option value="value">R$</option>
              </select>
            </div>
          </div>
        </div>

        <template v-if="form.definition.accredited === 'pj'">
          <div class="divider" />
          <span class="text-bold">Repassar aos profissionais</span>
          <div class="columns">
            <div class="column col-4 col-sm-12">
              <label class="form-switch">
                <input type="checkbox"
                       v-model="form.definition.insuranceTax"
                       :disabled="form.definition.accredited === 'pf'"/>
                <i class="form-icon"/>Imposto do plano
              </label>
            </div>
            <div class="column col-4 col-sm-12">
              <label class="form-switch">
                <input type="checkbox"
                       v-model="form.definition.operationalCost" />
                <i class="form-icon"/>Custo operacional
              </label>
            </div>
            <div class="column col-4 col-sm-12">
              <label class="form-switch">
                <input type="checkbox"
                       v-model="form.definition.film" />
                <i class="form-icon"/>Filme
              </label>
            </div>
            <div class="column col-4 col-sm-12 form-group">
              <label class="form-switch">
                <input type="checkbox"
                       v-model="form.definition.interest" />
                <i class="form-icon"/>Juros
              </label>
            </div>
            <div class="column col-4 col-sm-12 form-group">
              <label class="form-switch">
                <input type="checkbox"
                       v-model="form.definition.discount" />
                <i class="form-icon"/>Desconto
              </label>
            </div>
            <div class="column col-4 col-sm-12 form-group">
              <label class="form-switch">
                <input type="checkbox"
                       v-model="form.definition.rate" />
                <i class="form-icon"/>Taxa do cartão
              </label>
            </div>
          </div>
        </template>

        <div class="divider" />
        <span class="text-bold">Parâmetros</span>

        <div class="columns">
          <div class="column col-4 col-md-12 col-sm-12">
            <label class="form-switch">
              <input type="checkbox"
                     v-model="form.requireAuthorization"/>
              <i class="form-icon"/>Requer autorização do convênio
            </label>
          </div>
          <div class="column col-4 col-md-12 col-sm-12">
            <label class="form-switch">
              <input type="checkbox"
                     v-model="form.requireClinicalIndication"/>
              <i class="form-icon"/>Obrigatório indicação clínica
            </label>
          </div>
          <div class="column col-4 col-md-12 col-sm-12">
            <label class="form-switch">
              <input type="checkbox"
                     v-model="form.requireWayTechnique" />
              <i class="form-icon"/>Obrigatório campos via e técnica
            </label>
          </div>
          <div class="column col-4 col-md-12 col-sm-12">
            <label class="form-switch">
              <input type="checkbox"
                     v-model="form.definition.updateValuesByCbhpm"
              />
              <i class="form-icon"/>Permitir atualizar valores via CBHPM
            </label>
          </div>
          <div class="column col-4 col-md-12 col-sm-12">
            <label class="form-switch tooltip"
                   data-tooltip="Preenchimento manual de Guia prestador e operadora">
              <input type="checkbox"
                     v-model="form.definition.priorAuthorization"
              />
              <i class="form-icon"/>Autorização prévia
            </label>
          </div>
        </div>

        <div class="divider" />
        <span class="text-bold">Profissional credenciado</span>

        <div class="columns">
          <div class="column col-6 col-md-12 col-sm-12 form-group">
            <label class="form-switch">
              <input type="checkbox"
                     v-model="form.definition.accreditation.enabled"
              />
              <i class="form-icon"/>Utilizar o credenciamento de outro profissional no XML
            </label>
          </div>
          <div class="column col-6 col-md-12 col-sm-12 form-group"
               :class="{'has-error': $v.form.definition
            .accreditation.professional.key.$error}">
            <select id="accredited" class="form-select"
                    v-model="form.definition.accreditation.professional.key"
                    @change="setAccreditationData"
                    :disabled="!form.definition.accreditation.enabled">
              <option value="">[Selecione um profissional]</option>
              <option v-for="item in professionals" :value="item.key" :key="item.key">
                {{ item.name }}
                <template v-if="item.specialty">({{ item.specialty.name }})</template>
              </option>
            </select>
          </div>
        </div>
      </st-tab>
      <st-tab id="tab-exceptions" name="Exceções">
        <div class="stenci-group">
          <div class="columns">
            <div class="column centered">
              Nesta área você consegue personalizar as regras e valores por profissional.
            </div>
            <div class="column col-auto">
              <button
                class="btn btn-icon btn-icon-left btn-sm btn-secondary"
                @click="addException">
                <fa-icon :icon="['fal', 'plus']" />Adicionar exceção
              </button>
            </div>
          </div>
        </div>
        <div class="empty mt-2" v-if="form.professionals.length === 0">
          <div class="empty-icon">
            <fa-icon :icon="['fal', 'info-circle']" size="3x"/>
          </div>
          <p class="empty-title h5">Exceções</p>
          <p class="empty-subtitle">Nenhuma exceção cadastrada</p>
        </div>
        <table class="table" v-else>
          <thead>
          <tr>
            <th>Profissional</th>
            <th class="text-right" style="width: 70px">Cred.</th>
            <th class="text-right" style="width: 120px">
              Taxa (%)
              <span class="c-hand tooltip tooltip-left"
                    data-tooltip="PJ: Taxa da clínica | PF: taxa do profissional">
                  <fa-icon
                    class="text-info"
                    :icon="['fal', 'info-circle']"
                  />
                </span>
            </th>
            <th class="text-right" style="width: 120px">Valor plano</th>
            <th class="text-right" style="width: 120px">Valor paciente</th>
            <th class="text-right" style="width: 150px">Valor repasse</th>
            <th style="width: 40px"></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, i) in form.professionals" :key="i">
            <td>
              <span v-if="item.id">{{ item.name }}</span>
              <select class="form-select select-sm"
                      v-model="item.id"
                      @change="setProfessionalData(item.id, i)"
                      v-else
              >
                <option value="">[Selecione o profissional]</option>
                <option
                  v-for="professional in filteredProfessionals"
                  :value="professional.id"
                  :key="professional.id"
                >
                  {{ professional.name }}
                </option>
              </select>
            </td>
            <td>
              <select class="form-select select-sm"
                      v-model="item.accredited">
                <option value="pf">Sim</option>
                <option value="pj">Não</option>
              </select>
            </td>
            <td class="text-right">
              <div class="input-group">
                <dx-input-number
                  class="form-input input-sm"
                  v-model="item.taxValue"
                  :precision="2"
                  maxlength="6"
                />
                <select class="form-select select-sm"
                        style="max-width: 2.3rem; background-color: #f8f9fa"
                        v-model="item.taxType" v-if="item.accredited === 'pf'">
                  <option value="pf">PF</option>
                  <option value="pj">PJ</option>
                </select>
              </div>
            </td>
            <td class="text-right"
                :class="{'has-error': $v.form
                  .professionals.$each[i].$error}">
              <dx-input-number
                class="form-input input-sm"
                v-model="item.insuranceValue"
                @blur="$v.form.professionals.$each[i].$touch()"
                :precision="2"
              />
            </td>
            <td class="text-right"
                :class="{'has-error': $v.form
                  .professionals.$each[i].$error}">
              <dx-input-number
                class="form-input input-sm"
                v-model="item.particularValue"
                @blur="$v.form.professionals.$each[i].$touch()"
                :precision="2"
              />
            </td>
            <td class="text-right">
              <div class="input-group">
                <dx-input-number
                  class="form-input input-sm"
                  v-model="item.transferValue"
                  :precision="2"
                />
                <select class="form-select select-sm"
                        style="max-width: 2.4rem; background-color: #f8f9fa"
                        v-model="item.transferType">
                  <option value="percent">%</option>
                  <option value="value">R$</option>
                </select>
              </div>
            </td>
            <td class="text-right">
              <button
                class="btn btn-icon btn-action btn-sm btn-error"
                @click="removeException(i)">
                <fa-icon :icon="['fal', 'times']" />
              </button>
            </td>
          </tr>
          </tbody>
        </table>
      </st-tab>
    </st-tabs>
    <template v-slot:footer>
      <button class="btn btn-primary btn-icon btn-icon-left mr-1"
              @click="save">
        <fa-icon :icon="['fal', 'check']" />Atualizar
      </button>
      <button class="btn" @click="close">Sair</button>
    </template>
  </dx-modal>
</template>

<script>
import { mapActions } from 'vuex';
import { required } from 'vuelidate/src/validators';
import { maxValue, minLength } from 'vuelidate/lib/validators';
import { tables as expenseTables } from 'src/data/expense-tables';
import formMixin from '@/mixins/form';

export default {
  mixins: [formMixin],
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      expenseTables,
      professionals: [],
      form: this.formBlank(),
    };
  },
  mounted() {
    this.init();
  },
  validations() {
    const oneGreaterThanZero = (definition) => {
      if (!definition) return false;
      return definition.insuranceValue > 0 || definition.particularValue > 0;
    };

    const rules = {
      form: {
        code: { required, minLength: minLength(11) },
        tableCode: { required },
        definition: {
          secondSegment: { maxValue: maxValue(100) },
          accreditation: {
            professional: {
              key: {},
            },
          },
          insuranceValue: { required },
          particularValue: { required },
          oneGreaterThanZero,
        },
        professionals: { $each: { oneGreaterThanZero } },
      },
    };

    if (this.form.definition.accreditation.enabled) {
      rules.form.definition.accreditation.professional.key = { required };
    }

    return rules;
  },
  computed: {
    hasFee() {
      return this.form.definition.feeValue > 0
        || this.form.definition.operationalCostValue > 0
        || this.form.definition.filmValue > 0;
    },
    filteredProfessionals() {
      const ids = this.form.professionals.map(({ id }) => id);
      return this.professionals.filter(item => !ids.includes(item.id));
    },
  },
  methods: {
    ...mapActions({
      apiFetchProfessionals: 'apiFetchProfessionals',
    }),
    close() {
      this.$emit('close');
    },
    init() {
      this.form = this.clone(this.data);
      this.loadProfessionals();
    },
    loadProfessionals() {
      this.apiFetchProfessionals()
        .then((items) => {
          items.forEach((item) => {
            this.professionals.push({
              key: `${item.id}-${item.professional.specialties[0].code}`,
              id: item.id,
              name: item.name,
              council: item.professional.councils[0],
              specialty: item.professional.specialties[0],
            });
          });
        })
        .catch(() => {});
    },
    save() {
      this.$v.form.$touch();
      if (this.$v.form.$error) {
        return;
      }

      this.$emit('save', this.form);
    },
    changedAccreditation() {
      this.form.definition.taxType = this.form.definition.accredited;
    },
    calcInsuranceValueWithFee() {
      if (!this.hasFee) {
        return;
      }
      const filmValue = this.form.definition.filmValue || 0;
      const filmQty = this.form.definition.filmQuantity || 1;
      const ucoValue = this.form.definition.operationalCostValue || 0;
      const feeValue = this.form.definition.feeValue || 0;
      this.form.definition.insuranceValue = ucoValue
        + feeValue
        + (filmValue * filmQty);
    },
    addException() {
      const definition = this.clone(this.form.definition);
      definition.accreditation.enabled = false;
      definition.accreditation.professional = null;
      definition.insuranceTax = false;

      this.form.professionals.push({
        id: '',
        name: '',
        custom: true,
        ...definition,
      });
    },
    removeException(i) {
      this.form.professionals.splice(i, 1);
    },
    setProfessionalData(id, i) {
      const professional = this.professionals.find(item => item.id === id);
      this.form.professionals[i].name = professional.name;
    },
    setAccreditationData() {
      const { key } = this.form.definition.accreditation.professional;
      const foundProfessional = this.professionals.find(item => item.key === key);

      this.form.definition.accreditation.professional = {
        key,
        id: foundProfessional.id,
        name: foundProfessional.name,
        council: foundProfessional.council,
        specialty: foundProfessional.specialty,
      };
    },
    formBlank() {
      return {
        id: '',
        code: '',
        tableCode: '',
        return: null,
        breakInsurance: false,
        expense: {
          id: '',
          type: '',
          name: '',
          modality: '',
          specialty: {
            code: '',
            name: '',
          },
          billAs: null,
        },
        requireAuthorization: false,
        requireClinicalIndication: false,
        requireWayTechnique: false,
        professionals: [],
        definition: this.blankDefinition(),
      };
    },
    blankDefinition() {
      return {
        accreditation: {
          enabled: false,
          professional: {
            key: '',
            id: '',
            name: '',
            council: {
              name: '',
              state: '',
              record: '',
            },
            specialty: {
              code: '',
              name: '',
            },
          },
        },
        accredited: 'pj',
        chValue: '',
        chQuantity: '',
        secondSegment: '',
        operationalCostValue: '',
        filmValue: '',
        filmQuantity: '',
        feeValue: '',
        insuranceValue: 0,
        particularValue: 0,
        taxValue: '',
        taxType: 'pj',
        transferValue: 0,
        transferType: 'value',
        postageCode: '',
        tax: true,
        rate: true,
        discount: true,
        interest: true,
        operationalCost: true,
        film: true,
        insuranceTax: true,
        updateValuesByCbhpm: true,
        priorAuthorization: false,
        reportValue: '',
      };
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/scss/_variables.scss';
#update-expense-modal {
  .tab-panel {
    margin-top: $layout-spacing;
  }
}
</style>
